import { useContext, useMemo } from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../AppContext';
import { chipColors } from '../../lib/contrast';

type FileType = {
    id: string;
    label: string;
    color: string;
};

type Props = {
    type: string;
};

/**
 * Chip file type: user_photo, etc, etc ...
 */
export function SttChipFileType({ type }: Props): React.ReactElement {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();

    const fileType = useMemo((): FileType | undefined => {
        if (!type || !cxt?.constants?.fileTypes) return undefined;

        // Extract type from [[ft.xxx]] format and convert to uppercase
        const match = type.match(/^\[\[ft\.(.+)\]\]$/);
        const normalizedType = match
            ? match[1]?.toUpperCase()
            : type.toUpperCase();

        return cxt.constants.fileTypes.find(
            (e: FileType) => e.id === normalizedType,
        );
    }, [type, cxt?.constants?.fileTypes]);

    const label = useMemo((): string => {
        if (!fileType?.label) return type;
        const match = fileType.label.match(/^\[\[ft\.(.+)\]\]$/);
        if (match) {
            return t(`FT.${match[1]?.toUpperCase()}`);
        }
        return fileType.label;
    }, [fileType?.label, t, type]);

    if (!type || !fileType) {
        return <></>;
    }

    return (
        <Chip
            size="small"
            label={label}
            sx={{
                ...chipColors(fileType.color),
            }}
        />
    );
}
